import { proProfileByUuidQueryOptions } from "api/queries/pros";
import { queries as prosBaseQueries } from "domains/connect/containers/ProsBase/queries";
import type { ConnectSearchParams } from "domains/connect/routing";
import { queries as proProfileQueries } from "domains/pros/views/ProProfile/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = {
  splat: string | undefined;
  search: ConnectSearchParams & { pro_uuid?: string; market_id?: number };
  isAdmin: boolean;
};

export const proByUuidQuery = ({ search }: Pick<QueriesInput, "search">) =>
  proProfileByUuidQueryOptions(search.pro_uuid);

export const queries = ({ splat, search, isAdmin }: QueriesInput): Array<WarmableQuery> => {
  const { pro_uuid, market_id, ...connectSearch } = search;
  if (pro_uuid) return [proByUuidQuery({ search })];
  const proId = Number(splat);
  if (splat && proId > 0) return proProfileQueries({ proId, isAdmin });
  if (!splat && market_id) return prosBaseQueries({ search: connectSearch, marketId: market_id });
  return [];
};
